import Loader from "../Loader/Loader";

interface BuyButtonProps {
  label?: string;
  btnType?: "submit" | "reset" | "button" | undefined;
  loadings?: boolean;
  classNames?: string;
  style?: object;
  onButtonClick: () => void;
  icon?: string;
}

const BuyButton = ({
  label = "Buy Now",
  btnType = "button",
  loadings = false,
  classNames,
  style = {},
  onButtonClick,
  icon = "",
}: BuyButtonProps) => {
  return (
    <>
      {loadings && <Loader />}
      <button
        type={btnType}
        className={`text-white rounded-pill py-2 px-3 ${classNames || ""}`}
        onClick={() => onButtonClick()}
        style={{
          backgroundColor: "#3F41D1",
          ...style,
        }}
      >
        {icon && <i className={icon} aria-hidden="true"></i>}
        {label}
      </button>
    </>
  );
};
export default BuyButton;
